import React from 'react';
import WorkplaceManagementItemButtons from '../ManagerWorkplaceItemButtons/ManagerWorkplaceItemButtons';
import { WorkplacesTreeItem } from '../ManagerWorkplaceWrapper/ManagerWorkplaceWrapper';

interface Props {
	item: WorkplacesTreeItem;
	openEditModal: (isOpen: boolean) => void;
	openDeleteModal: (isOpen: boolean) => void;
}

const ManagerWorkplaceItemActions = ({
	item,
	openEditModal,
	openDeleteModal,
}: Props) => {
	return (
		<WorkplaceManagementItemButtons
			item={item}
			openEditModal={openEditModal}
			openDeleteModal={openDeleteModal}
		/>
	);
};

export default ManagerWorkplaceItemActions;
